import React from "react";
import styled from "styled-components";
import {device} from "../../constants/media";

const Container = styled.div`
  @media ${device.below.tablet} {
    flex-direction: column;
    margin: 0;
  }
  flex-direction: row;
  margin-top: 40px;

  display: flex;
  min-height: 250px;
`;

const CoverContainer = styled.div`
  @media ${device.below.tablet} {
    margin: 0.5rem 0;
    width: 100%;
  }
  margin: 0 0.5rem;

  width: 300px;
  overflow: hidden;
`;

const Cover = styled.img`
  margin: auto;
  width: 100%;
`;

const InfoContainer = styled.div`
  @media ${device.below.tablet} {
    margin: 0.5rem 0;
  }
  margin: 0 0.5rem;

  flex: 1;
  border-top: solid 3px #000;
  position: relative;
`;

const Title = styled.h3`
  text-justify: none;
  font-size: 1rem;
  color: #333;
  margin-top: 1rem;
`;

class ServiceItem extends React.Component {
  getContent() {
    return <div dangerouslySetInnerHTML={{__html: this.props.post.text}} />;
  }

  render() {
    const post = this.props.post;

    return (
      <Container>
        <CoverContainer single={this.props.single}>
          <Cover src={post.cover} />
        </CoverContainer>

        <InfoContainer>
          <Title>{post.title}</Title>
          {this.getContent()}
        </InfoContainer>
      </Container>
    );
  }
}

export default ServiceItem;
